// TODO: Improve types
/**
 * Locales supported by HubSpot forms
 */
var HubSpotFormLocale;
(function (HubSpotFormLocale) {
    HubSpotFormLocale["ENGLISH"] = "en";
    HubSpotFormLocale["DANISH"] = "da";
    HubSpotFormLocale["GERMAN"] = "de";
    HubSpotFormLocale["SPANISH"] = "es";
    HubSpotFormLocale["SPANISH_MEXICO"] = "es-mx";
    HubSpotFormLocale["FINNISH"] = "fi";
    HubSpotFormLocale["FRENCH"] = "fr";
    HubSpotFormLocale["ITALIAN"] = "it";
    HubSpotFormLocale["JAPANESE"] = "ja";
    HubSpotFormLocale["DUTCH"] = "nl";
    HubSpotFormLocale["POLISH"] = "pl";
    HubSpotFormLocale["PORTUGUESE"] = "pt-br";
    HubSpotFormLocale["SWEDISH"] = "sv";
    HubSpotFormLocale["CHINESE"] = "zh-cn";
    HubSpotFormLocale["CHINESE_HONG_KONG"] = "zh-hk";
})(HubSpotFormLocale || (HubSpotFormLocale = {}));

export { HubSpotFormLocale };
